export const EmploymentEquitySalary = `EmploymentEquitySalary/`;

export const GetSalariesByIndividualId = (individualId: number) =>{
    return `${EmploymentEquitySalary}individual/${individualId}`;
} 

export const GetSalariesByIndividualIdForYears = (individualId: number) =>{
    return `${EmploymentEquitySalary}individual/${individualId}/years`;
}

export const DeleteSalariesByIndividualIdForYear = (individualId: number, year: number) =>{
    return `${EmploymentEquitySalary}individual/${individualId}/years/${year}`;
}

export const AddSalariesByIndividualIdForYear = (individualId: number, year: number) =>{
    return `${EmploymentEquitySalary}individual/${individualId}/year/${year}`;
}

export const SaveSalariesByIndividualIdForYear = (individualId: number) =>{
    return `${EmploymentEquitySalary}individual/${individualId}`;
}

export const Search = EmploymentEquitySalary + 'Search';